export const formatPhoneNumber = (phoneNumber) => {
    // Remove any leading '+', spaces, or non-numeric characters
    const digits = phoneNumber.replace(/\D/g, "");
    // Extract area code and the main phone number
    let areaCode, mainNumber;

    if (digits.length === 12 && digits.startsWith("55")) {
        // Extracts '51' from '+555193036928'
        areaCode = digits.slice(2, 4);
        // Extracts '93036928'
        mainNumber = digits.slice(4);
    } else if (digits.length === 11) {
        // Handles already properly sized numbers without country code
        areaCode = digits.slice(0, 2);
        mainNumber = digits.slice(2);
        const formattedNumber = `(${areaCode}) 9 ${mainNumber?.slice(
            1,
            5
        )}-${mainNumber?.slice(5)}`;
        return formattedNumber;
    } else if (digits.length === 13 && digits.startsWith("55")) {
        // Handles already properly sized numbers without country code
        areaCode = digits.slice(2, 4);
        mainNumber = digits.slice(2);
        const formattedNumber = `(${areaCode}) 9 ${mainNumber?.slice(
            3,
            7
        )}-${mainNumber?.slice(7)}`;
        return formattedNumber;
    } else if (digits.length === 10 && digits.startsWith("5")) {
        // Handles already properly sized numbers without country code
        areaCode = digits.slice(0, 2);
        mainNumber = digits.slice(0);
        const formattedNumber = `(${areaCode}) 9 ${mainNumber?.slice(
            2,
            6
        )}-${mainNumber?.slice(6)}`;
        return formattedNumber;
    } else {
        console.log("Invalid area code");
        console.log(digits.length);
        console.log(digits);

        // throw new Error("Invalid phone number format");
    }

    // Format the main number with an extra '9' after area code
    const formattedNumber = `(${areaCode}) 9 ${mainNumber?.slice(
        0,
        4
    )}-${mainNumber?.slice(4)}`;

    return formattedNumber;
};

export const convertTimeStamp = (time) => {
    const timestamp = Number(time);

    // Create a Date object from the timestamp
    const date = new Date(timestamp);

    // Extract the day, month, and year
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();

    // Format the date as "dd/mm/yyyy"
    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate
}

export const formatCPF = (cpf) => {
    // Convert the number to a string if it's not already
    const cpfStr = String(cpf);

    // Format the string using substring
    const formattedCPF = cpfStr.slice(0, 3) + '.' +
        cpfStr.slice(3, 6) + '.' +
        cpfStr.slice(6, 9) + '-' +
        cpfStr.slice(9, 11);

    return formattedCPF;
}



export const formatBrDate = (date) => {
    if (!date) {
        return "-"
    }
    const formDate = date?.split('-').reverse().join('/')
    return formDate
}

export const formatExcelData = (data) => {
    const newObjArr = data.slice(1).map((info) => {
        return ({
            [data[0][0]]: info[0],
            [data[0][1]]: info[1],
            [data[0][2]]: info[2],
            [data[0][3]]: info[3],
            [data[0][4]]: '',
        })
    })
    return newObjArr
}
export const formatCsvDataExport = (data) => {
    const csvFile = [
        [

            'id_produto',
            'Preço',
            'Tipo',
            'Inserido',
            'Cliente'
        ]
    ]

    // Iterate over each product in the data array
    data.sort((b, a) => String(b.product_id).localeCompare(String(a.product_id), 'pt', { numeric: true })).forEach(ele => {
        // Create a new line for the CSV based on the product's quantity
        for (let i = 0; i < ele.quantity; i++) {
            const newLine = [
                ele.product_id,
                ele.sell_price.toLocaleString().replace('.', ','),
                ele.content_type,
                formatDateCreatedAt(ele.created_at),
                '' // You can replace this with another value if needed
            ];
            csvFile.push(newLine); // Push the new line into the csvFile
        }
    })

    return csvFile
}


export const formatDateCreatedAt = (dateString) => {
    // Create a new Date object from the date string
    const date = new Date(dateString);

    // Format the date components
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();

    // Format the time components
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Combine formatted components into the desired format
    return `${day}/${month}/${year} - ${hours}:${minutes}`;
}

export const formatCep = (cep) => {
    if (!cep) {
        return '-'
    }
    // Ensure the CEP is a string and has 8 digits
    cep = cep.toString().padStart(8, '0');

    // Format the CEP with the desired pattern
    return `${cep.slice(0, 2)}.${cep.slice(2, 5)}-${cep.slice(5)}`;
}


export const formatToBRL = (value) => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(value);
}
